import React, { Component } from "react";

import { Table, Card, Row, Col, Form, Image } from "react-bootstrap";
import ReactPaginate from "react-paginate";
import PatientInvoiceView from "../PatientInvoice/PatientInvoiceView";
import PatientInvoiceStatusChange from "../PatientInvoice/PatientInvoiceStatusChange";

import "../../Common/Common.css";
var dateFormat = require("dateformat");

class PatientInvoice extends Component {
  constructor(props) {
    super(props);
    this.state = {
      PatientInvoiceShow: false,
      showPatientInvoiceActive: false,
      page: 0,
      perPage: 10,
      searchPatientInvoice: "",
      filterValue: "",
    };
  }

  componentDidMount() {
    this.props.patientInvoiceList({
      page: undefined,
      search: this.state.searchPatientInvoice,
      filter: this.state.filterValue,
    });
  }

  handlePatientInvoiceView = (item) => {
    this.setState({
      PatientInvoiceShow: true,
      PatientInvoiceDtls: item,
    });
  };

  handleClosePatientInvoiceView = () => {
    this.setState({ PatientInvoiceShow: false });
  };

  handlePageClick = (e) => {
    const selectedPage = e.selected;
    this.props.PatientInvoiceSelectedPage({
      page: selectedPage + 1,
      search: this.state.searchPatientInvoice,
      filter: this.state.filterValue,
    });
    this.setState({ page: selectedPage });
  };
  resetPage = () => {
    this.setState({ page: 0 });
  };

  handlePatientInvoiceActiveView = (item) => {
    this.setState({
      showPatientInvoiceActive: true,
      PatientInvoiceActiveDtls: item,
    });
  };
  handleCloseActive = () => {
    this.setState({ showPatientInvoiceActive: false });
  };

  SearchOnChange = (event) => {
    this.setState(
      {
        searchPatientInvoice: event.target.value,
        page: 0,
      },
      () => {
        this.props.patientInvoiceList({
          page: undefined,
          search: this.state.searchPatientInvoice,
          filter: this.state.filterValue,
        });
      }
    );
  };

  handleChange = (event) => {
    this.setState(
      {
        filterValue: event.target.value,
        page: 0,
      },
      () => {
        this.props.patientInvoiceList({
          page: undefined,
          search: this.state.searchPatientInvoice,
          filter: this.state.filterValue,
        });
      }
    );
  };

  render() {
    let p = this.state.page + 1;
    const count =
      this.props.patientInvoiceDtlsCount && this.props.patientInvoiceDtlsCount;
    let PatientInvoicePageCount = Math.ceil(count / this.state.perPage);

    return (
      <div>
        <Card>
          <Card.Header>
            <Row className="align-items-center w-100 justify-content-between tableHeaderRow">
              <Col xs={12} sm={12} md={3} lg={3}>
                <h3>Patient Invoices</h3>
              </Col>

              <Col xs={12} sm={12} md={3} lg={3}>
                <div className="commonFilterDiv">
                  <select
                    value={this.state.filterValue}
                    onChange={this.handleChange}
                    className="commonFilterSelect"
                  >
                    <option value="">All</option>
                    <option value="open">Open</option>
                    {/* <option value="partial">Partial</option> */}
                    <option value="paid">Paid</option>
                    <option value="cancelled">Cancelled</option>
                  </select>
                </div>
              </Col>
              <Col xs={12} sm={12} md={3} lg={3}>
                <div>
                  <div className="commonInput">
                    <i className="fa fa-search fa-lg cmnSearchIcon"></i>
                    <input
                      type="text"
                      placeholder="Reference No/ Order ID"
                      value={this.state.searchPatientInvoice}
                      onChange={this.SearchOnChange}
                    />
                  </div>
                </div>
              </Col>
              <Col xs={12} sm={12} md={3} lg={3}>
                <div className="commonRecrd">
                  <i className="cui-note icons cmnRecordIcon"></i>
                  <span className="cmnPageCount">
                    {count !== undefined ? count : 0}
                  </span>
                  <span className="cmnResutText">Results</span>
                </div>
              </Col>
            </Row>
          </Card.Header>
          <Card.Body>
            <div>
              <Table responsive bordered striped className="cmnMainTable">
                <thead>
                  <tr className="cmnMainTableHd">
                    <th>SL NO</th>
                    <th>REFERENCE NO</th>
                    <th>ORDER ID</th>
                    <th>ORDER TYPE</th>
                    <th>CHEMIST</th>
                    <th>CUSTOMER NAME</th>
                    <th>AMOUNT</th>
                    <th>STATUS</th>
                    <th>ACTION</th>
                  </tr>
                </thead>
                <tbody>
                  {this.props.patientInvoiceDtlsList &&
                    this.props.patientInvoiceDtlsList.map((item, i) => (
                      <tr key={i}>
                        <td className="cmn_Cap">{10 * (p - 1) + i + 1}</td>
                        <td className="">{item.invNo}</td>
                        <td className="cmn_Cap ">{item.orderId.orderNo}</td>
                        <td className="cmn_Cap">{item.orderType}</td>
                        <td className="cmn_Cap">
                          {item.dstbtrDtls !== null && item.dstbtrDtls.name}
                        </td>
                        <td className="cmn_Cap">
                          {item.vendorId !== null && item.vendorId.fullName}
                        </td>
                        <td className="rightAlign">{item.payableAmnt}</td>
                        <td className="cmn_Cap ">{item.status}</td>

                        <td className="cmnViewIcon">
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                            }}
                          >
                            <i
                              className="fa fa-eye fa-lg "
                              onClick={() =>
                                this.handlePatientInvoiceView({ item: item })
                              }
                            ></i>

                            <i
                              className="fa fa-ban fa-lg"
                              style={{ paddingLeft: 10 }}
                              onClick={() =>
                                this.handlePatientInvoiceActiveView({
                                  item: item,
                                })
                              }
                            ></i>
                            <PatientInvoiceStatusChange
                              show={this.state.showPatientInvoiceActive}
                              handleClose={this.handleCloseActive}
                              PatientInvoiceActiveDtls={
                                this.state.PatientInvoiceActiveDtls
                              }
                              refreshParams={{
                                page: 1,
                                search: this.state.searchPatientInvoice,
                                filter: this.state.filterValue,
                              }}
                              PatientInvoiceStatusChange={
                                this.props.PatientInvoiceStatusChange
                              }
                              resetPage={this.resetPage}
                            />
                          </div>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </Table>
              <PatientInvoiceView
                show={this.state.PatientInvoiceShow}
                handleClose={this.handleClosePatientInvoiceView}
                PatientInvoiceDtls={this.state.PatientInvoiceDtls}
              />

              {(this.props.patientInvoiceDtlsList === undefined ||
                (this.props.patientInvoiceDtlsList &&
                  this.props.patientInvoiceDtlsList.length === 0)) && (
                <div>
                  <div className="noDataImgDiv">
                    <Image
                      className="noDataImg"
                      src={require("../../../../src/assets/img/nodata4.png")}
                    />
                  </div>
                  <div className="noDataTextDiv">No Invoices Found</div>
                </div>
              )}
            </div>
          </Card.Body>
          {PatientInvoicePageCount > 1 ? (
            <div className="paginationDiv">
              <ReactPaginate
                forcePage={this.state.page}
                previousLabel={"Prev"}
                nextLabel={"Next"}
                breakLabel={"..."}
                breakClassName={"break-me"}
                pageCount={PatientInvoicePageCount}
                marginPagesDisplayed={2}
                pageRangeDisplayed={5}
                onPageChange={this.handlePageClick}
                containerClassName={"pagination flex-wrap"}
                subContainerClassName={"pages pagination"}
                activeClassName={"active"}
              />
            </div>
          ) : null}
        </Card>
      </div>
    );
  }
}
export default PatientInvoice;
